import { ShippingRateKind } from '@nucleus-commerce/api-client/admin';

export const RATE_KINDS = Object.values(ShippingRateKind);

export interface RateFields {
  /** The shopper pays this; free_over rates are free by definition. */
  price: boolean;
  weightBand: boolean;
  subtotalBand: boolean;
  /** Single lower bound on the subtotal (free_over). */
  threshold: boolean;
}

/** Which inputs a rate of this kind needs; the dialog shows only those and the mapper clears the rest. */
export function rateFieldsFor(kind: ShippingRateKind): RateFields {
  switch (kind) {
    case 'flat':
      return { price: true, weightBand: false, subtotalBand: false, threshold: false };
    case 'weight':
      return { price: true, weightBand: true, subtotalBand: false, threshold: false };
    case 'price':
      return { price: true, weightBand: false, subtotalBand: true, threshold: false };
    case 'free_over':
      return { price: false, weightBand: false, subtotalBand: false, threshold: true };
  }
}

/** Whole non-negative number typed into a text input; blank is "unset". */
export function parseWhole(value: string): number | null {
  const trimmed = value.trim();
  return trimmed === '' ? null : Number(trimmed);
}
